import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import {
	ProductAddOnInterface,
	ProductInterface,
	QuotationInterface,
	MotorRequestInterface,
	PromoCodeInterface,
	ProductDocumentInterface,
} from "../interface/motor-quotation.interface";
import { Observable } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class OrderDataService {
	private basePath: string = `${environment.url}/api/Order/`;
  private crmBasePath: string = `${environment.crmUrl}/api/Motor/MotorQuotation/`;

	constructor(private http: HttpClient) { }

	getDetailById(id: string) {
		return this.http.get<MotorRequestInterface>(
			`${this.basePath}GetRequestInfoById/${id}`,
		);
	}

	getQuotationById(id: string, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.get<QuotationInterface[]>(
			`${this.basePath}GetQuotation/${id}`,
			{
				headers,
			},
		);
	}

	getEppBankInstallmentList(dealerType: string, promoCodeId: string = null) {
		let path = `${this.basePath}GetEppRates?dealerType=${dealerType}`;

		if(promoCodeId)
		{
			path += `&promoCodeId=${promoCodeId}`
		}
		
		return this.http.get<any>(path);
	}

	getNonQuoteProduct(id: string) {
		return this.http.get<ProductInterface[]>(
			`${this.basePath}GetNonQuoteProduct/${id}`,
		);
	}

	getAddOn(id: string, quotationId: string, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.get<ProductAddOnInterface[]>(
			`${this.basePath}GetAddOn/${id}?quotationId=${quotationId}`,
			{
				headers,
			},
		);
	}

	applyPromoCode(id: string, code: string, totalCharge: number, dealerRepId: string) {
		return this.http.post<PromoCodeInterface>(
			`${this.basePath}PromoCode/${id}`,
			{
				code,
				totalCharge,
				dealerRepId
			},
		);
	}

	getProductDocumentById(id: string, language: string, insuranceType: string) {
		return this.http.get<ProductDocumentInterface[]>(
			`${this.basePath}GetProductDocument?id=${id}&language=${language}&insuranceType=${insuranceType}`,
		);
	}

	generatePayment(id: string, val: any) {
		return this.http.post<{ id: string }>(
			`${this.basePath}GeneratePayment/${id}`,
			val,
		);
	}

	editExistingQuotes(id: string, values: any, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.post<any>(
			`${this.basePath}EditExistingQuotes/${id}`,
			values,
			{
				headers,
			},
		);
	}

	editSpecificQuotes(id: string, values: any, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.post<any>(
			`${this.basePath}EditSpecificQuotes/${id}`,
			values,
			{
				headers,
			},
		);
	}

	getHirePurchaseList() {
		return this.http.get<any>(`${this.basePath}GetHirePurchaseList`);
	}

	getAllProduct(insuranceType: string, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.get<any>(
			`${this.basePath}GetAllProduct?insuranceType=${insuranceType}`,
			{
				headers,
			},
		);
	}

	submitOrder(id: string, formData: FormData, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);

		return this.http.post<string>(
			`${this.basePath}SubmitOrder/${id}`,
			formData,
			{
				headers,
				responseType: "text" as "json",
			},
		);
	}

	checkPayment(refNo: string) {
		return this.http.get<{ status: boolean; data: any; amount: number }>(
			`${this.basePath}CheckPayment?refNo=${refNo}`,
		);
	}

	editCarVariant(linkId: string, vehicleId: string) {
		return this.http.post<any>(
			`${this.basePath}EditCarVariant/${linkId}?vehicleId=${vehicleId}`,
			null,
		);
	}

	saveOrder(id: string, formData: FormData, partnerCode: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);

		return this.http.post<string>(
			`${this.basePath}SaveOrder/${id}`,
			formData,
			{
				headers,
				responseType: "text" as "json",
			},
		);
	}

	getOrderByLinkId(id: string) {
		return this.http.get<any>(
			`${this.basePath}GetOrder/${id}`,
		);
	}

	getAllProductByDealerType(id: string, partnerCode: string, dealerType: string) {
		const headers = new HttpHeaders().set("partnerCode", partnerCode);
		return this.http.get<any>(
			`${this.basePath}GetAllProductByDealerType/${id}?dealerType=${dealerType}`,
			{
				headers,
			},
		)
	}

	GetAvailableProductByLinkId(id: string) {
		return this.http.get<any>(
			`${this.basePath}GetAvailableProductByLinkId/${id}`,
		);
  }

	submitExtraProduct(id: string, typeOfSum: string, idList: string[]) {
    return this.http.post(`${this.basePath}SubmitExtraProduct/${id}`, {
      typeOfSum,
      selectedMotorProductIds: idList,
    });
  }

	editRequest(id: string, val: any) {
		return this.http.post<void>(`${this.basePath}EditRequest/${id}`, val);
	}

	getIsExistingUserDupeRequest(id: string, val: any): Observable<boolean> {
    return this.http.post<boolean>(`${this.basePath}GetIsExistingUserDupeRequest/${id}`, val);
	}

	getBNPLRateListByPortal(portal: string) {
		return this.http.get(`${this.basePath}GetBNPLRateListByPortal?portal=${portal}`);
	}

  getGeneraliQuotationPricing(id: string, selectedAddOns: any[], addDriversInfo: any[], windshieldSI: number, gcktSI: number, cartDays: number, cartDailyCoverage: number){
    return this.http.post(`${this.crmBasePath}GetGeneraliQuotationPricing/${id}`, {selectedAddOns, addDriversInfo, windshieldSI, gcktSI, cartDays, cartDailyCoverage})
  }

	processGeneraliOrder(quotationId: string, infoValue: any){
		return this.http.post(`${this.crmBasePath}GeneraliGetOrder/${quotationId}`, infoValue);
	}

	getChubbQuotationPricing(
		id: string, 
		selectedAddOns: any[], 
		windshieldSI: number,
		selectedAvailableInsurerCarPlus: string
	){
		return this.http.post(`${this.crmBasePath}GetChubbQuotationPricing/${id}`, {
			selectedAddOns, 
			windshieldSI,
			selectedAvailableInsurerCarPlus
		});
	}

	getTMIMQuotationPricing(id: string, selectedAddOns: any[], windshieldSI: number, driverCount: number, isHirePurchase: boolean, loanComName: string) {
    const requestData = {
      QuotationId: id,
      SelectedAddon: selectedAddOns,
      windscreenValue: windshieldSI,
      DriverCount: driverCount,
			IsHirePurchase: isHirePurchase,
			LoanComName: loanComName
    };
		
    return this.http.post(`${this.crmBasePath}GetTMIMFinalPrem`, requestData);
  }

	getZurichQuotationPricing(
		id: string,
		selectedAddOns: any[],
		addDriversInfo: any[],
		windshieldSI: number,
		IsZurichTakafulIQ: boolean,
		isHirePurchase: boolean, 
		loanCompanyName: string,
		effectiveDate: string | null
	) {
		return this.http.post(
			`${this.crmBasePath}GetZurichQuotationPricing/${id}`,
			{ 
				selectedAddOns, 
				addDriversInfo, 
				windshieldSI, 
				IsZurichTakafulIQ,
				isHirePurchase,
				loanCompanyName,
				effectiveDate
			}
		);
	}

	processChubbOrder(quotationId: string, infoValue: any){
		return this.http.post(`${this.crmBasePath}ChubbGenQuotation/${quotationId}`, infoValue);
	}

	getCARTAddOnPriceList() {
    return this.http.get(`${this.basePath}GetCARTAddOnPriceList`);
  }

  getAllianzQuotationPricing(
    quotationId: string, 
    selectedAddOns: any[],
    windshieldSI: number,
    cartDays: number,
    cartAmount: number,
    gcktSI: number,
    additionalDriverInfo: any[]) {
    return this.http.post(
      `${this.crmBasePath}GetAllianzQuotationPricing/${quotationId}`,
      {
        selectedAddOns,
        windshieldSI,
        cartDays,
        cartAmount,
        gcktSI,
        additionalDriverInfo
      }
    );
  }

  checkAllianzE2EQuotationValidity(quotationId: string){
    return this.http.get<boolean>(`${this.crmBasePath}CheckAllianzE2EQuotationValidity/${quotationId}`);
  }

  checkAllianzPremiumsBeforePayment(
    quotationId: string, 
    selectedAddOns: any[],
    windshieldSI: number,
    cartDays: number,
    cartAmount: number,
    gcktSI: number,
    additionalDriverInfo: any[]) {
    return this.http.post(`${this.crmBasePath}CheckAllianzE2EPremiumsBeforePayment/${quotationId}`, 
      {
        selectedAddOns,
        windshieldSI,
        cartDays,
        cartAmount,
        gcktSI,
        additionalDriverInfo
      }
    );
  }
}
